export default "__VITE_ASSET__B21KzD1i__"